











import Vue from 'vue';
import { mapGetters } from 'vuex';
import pxCard from '@/dex-shared/components/px-card.vue';
import Icon from '@/dex-shared/components/Icon.vue';

export default Vue.extend({
  components: {
    pxCard,
    Icon,
  },
  props: {
    examinationBoardId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      examinationBoardById: 'examinationBoardById',
    }),
    examinationBoard() {
      return this.examinationBoardById(this.examinationBoardId);
    },
  },
  methods: {
    removeExaminationBoard: async function() {
      if (
        confirm(
          'Tem certeza que deseja deletar essa banca? Ela não poderá ser recuperada!',
        )
      ) {
        const response = await this.$store.dispatch(
          'REMOVE_EXAMINATION_BOARD',
          this.examinationBoardId,
        );

        if (response !== true) {
          //TODO analyze the error
          alert('Essa banca não pode ser deletada!');
        }
      }
    },
  },
});
